import { post, get, postData } from './http'
import global from '@/api/global'
var tmsPlus = global.tmsPlus
var wmsCenter = global.wmsCenter
var driverName = global.driverNameT
var wmsAccessName = global.wmsAccessName
var vehMonitor = global.vehMonitor
var tmsMonitor = 'tms-monitor-server/monitor'
var crmServer3 = global.crmServer3
var signature = global.signature
// 字段管理
export const getDictionaryMasterList = p => post(`${tmsPlus}/dictionary/getDictionaryMasterList`, p)// 列表查询
export const getDictionaryDetailList = p => post(`${tmsPlus}/dictionary/getDictionaryDetailList`, p)// 字典管理-维护列表查询
export const addOrUpDictionaryDetail = p => post(`${tmsPlus}/dictionary/addOrUpDictionaryDetail`, p)// 字典管理-字典维护新增或修改或删除
export const addOrUpFinancialSettings = p => post(`${tmsPlus}/dictionary/addOrUpFinancialSettings`, p)// 财务设置新增或修改或删除
// 车辆管理
// 车辆管理列表查询
export const findVehicleInfoList = p => post(`${tmsPlus}/vehicleInfo/findVehicleInfoList`, p)
// 添加车辆
export const addVehicleInfoList = p => post(`${tmsPlus}/vehicleInfo/addVehicleInfoList`, p)
// 修改车辆
export const updateVehicleInfoList = p => post(`${tmsPlus}/vehicleInfo/updateVehicleInfoList`, p)
// 删除车辆
export const deleteVehicleInfo = p => post(`${tmsPlus}/vehicleInfo/deleteVehicleInfo`, p)
// 导入车辆
export const importVehicleInfo = p => post(`${tmsPlus}/vehicleInfo/importVehicleInfo`, p)
// 司机管理
// 司机管理列表查询
export const findDriverInfoList = p => post(`${tmsPlus}/driverInfo/findDriverInfoList`, p)
// 添加司机
export const addDriverInfoList = p => post(`${tmsPlus}/driverInfo/addDriverInfoList`, p)
// 修改司机
export const updateDriverInfoList = p => post(`${tmsPlus}/driverInfo/updateDriverInfoList`, p)
// 删除司机
export const deleteDriverInfo = p => post(`${tmsPlus}/driverInfo/deleteDriverInfo`, p)
// 司机导入
export const importDriverInfo = p => post(`${tmsPlus}/driverInfo/importDriverInfo`, p)
// 地址列表
export const sAddressList = p => post(`/${tmsPlus}/sAddress/list`, p)
// 新增地址
export const sAddressAdd = p => post(`/${tmsPlus}/sAddress/add`, p)
// 修改地址
export const sAddressUpdate = p => post(`/${tmsPlus}/sAddress/update`, p)
// 删除地址
export const sAddressDelete = p => post(`/${tmsPlus}/sAddress/delete`, p)
// 客户管理&承运商管理列表查询
export const findCustomerInfoList = p => post(`/${tmsPlus}/customerInfo/findCustomerInfoList`, p)
// crm查客户
export const selectCustomerDetail = p => post(`${crmServer3}/api/selectCustomerDetail`, p)
// 添加客户管理/承运商管理
export const addCustomerInfo = p => post(`/${tmsPlus}/customerInfo/addCustomerInfo`, p)
// 修改客户管理/承运商管理
export const updateCustomerInfo = p => post(`/${tmsPlus}/customerInfo/updateCustomerInfo`, p)
// 删除客户管理/承运商管理
export const deleteCustomerInfo = p => post(`/${tmsPlus}/customerInfo/deleteCustomerInfo`, p)
// 客户/承运商添加合同
export const addCustomerContract = p => post(`/${tmsPlus}/customerContract/addCustomerContract`, p)
// 查询合同
export const findCustomerContractList = p => post(`/${tmsPlus}/customerContract/findCustomerContractList`, p)
// 修改合同
export const updateCustomerContract = p => post(`/${tmsPlus}/customerContract/updateCustomerContract`, p)
// 删除合同
export const deleteCustomerContract = p => post(`/${tmsPlus}/customerContract/deleteCustomerContract`, p)
// 查看文件
export const getFileShow = p => post(`/${tmsPlus}/tAttachments/getFileShow`, p)
// 删除文件
export const deleteFile = p => post(`/${tmsPlus}/tAttachments/deleteFile`, p)
// 客户管理绑定业务人员
export const saveBusinessUser = p => post(`/${tmsPlus}/customerInfo/saveBusinessUser`, p)
// 查询历史绑定的业务人员记录列表
export const findCustomerBusinessUserList = p => post(`/${tmsPlus}/customerInfo/findCustomerBusinessUserList`, p)
// 动态字段设置及查询接口
// 查询要设置的字段表头
export const queryAllSettingFiles = p => post(`/${tmsPlus}/dynamic/field/queryAllSettingFiles`, p)
// 查询我的已设置字段表头
export const queryYesSettingFiles = p => post(`/${tmsPlus}/dynamic/field/queryYesSettingFiles`, p)
// 新增或更新已设置字段表头
export const saveOrUpdateOrRemove = p => post(`/${tmsPlus}/dynamic/myField/saveOrUpdateOrRemove`, p)
// 查询我的页面表头
export const queryMyPageField = p => post(`/${tmsPlus}/dynamic/field/queryMyPageField`, p)
// 订单列表
export const findOrderList = p => post(`/${tmsPlus}/order/findOrderList`, p)
// 订单新增
export const addOrder = p => post(`/${tmsPlus}/order/addOrder`, p)
// 订单新增货物导入
export const importOrderGoods = p => post(`/${tmsPlus}/order/importOrderGoods`, p)
// 订单详情
export const getOrderInfo = p => post(`/${tmsPlus}/order/getOrderInfo`, p)
// 订单修改
export const updateOrder = p => post(`/${tmsPlus}/order/updateOrder`, p)
// 订单作废
export const cancellationOrder = p => post(`/${tmsPlus}/order/cancellationOrder`, p)
// 订单删除货物
export const deleteOrderGoods = p => post(`/${tmsPlus}/order/deleteOrderGoods`, p)
// 转包
export const subcontract = p => post(`/${tmsPlus}/order/subcontract`, p)
// 取消转包
export const cancelSubcontract = p => post(`/${tmsPlus}/order/cancelSubcontract`, p)
// 查询待指派的货物
export const findAssignmentGoods = p => post(`/${tmsPlus}/order/findAssignmentGoods`, p)
// 无货指派
export const noCargoStowage = p => post(`/${tmsPlus}/order/noCargoStowage`, p)
// 有货指派
export const cargoStowage = p => post(`/${tmsPlus}/order/cargoStowage`, p)
// 附件列表
export const getOrderAttachments = p => post(`/${tmsPlus}/order/getOrderAttachments`, p)
// 修改订单时判断货物是否可以删除
export const checkOrderGoods = p => post(`/${tmsPlus}/order/checkOrderGoods`, p)
// 判断订单下是否生成运单
export const checkOrderWay = p => post(`/${tmsPlus}/order/checkOrderWay`, p)
// 根据订单id查剩余量
export const findStowageOrderList = p => post(`/${tmsPlus}/order/findStowageOrderList`, p)
// 分段
export const sectionOpenOrde = p => post(`/${tmsPlus}/order/sectionOpenOrde`, p)
// 分段拆单子信息
export const findSonSectionList = p => post(`/${tmsPlus}/order/findSonSectionList`, p)
// 删除子分段拆单校验
export const deleteSectionCheckv = p => post(`/${tmsPlus}/order/deleteSectionCheck`, p)
// 修改分段
export const updateSectionOpenOrde = p => post(`/${tmsPlus}/order/updateSectionOpenOrde`, p)
// 取消分段
export const cancelSectionOpenOrde = p => post(`/${tmsPlus}/order/cancelSectionOpenOrde`, p)
// 订单完成
export const completeOrder = p => post(`/${tmsPlus}/order/completeOrder`, p)
// 判断订单是否可以修改
export const checkUpdateOrder = p => post(`/${tmsPlus}/order/checkUpdateOrder`, p)
// 查询仓库货物
export const getWhOutstockPlanCargoList = p => post(`/${wmsCenter}/tms/getWhOutstockPlanCargoList`, p)
// 运单管理===
// 运单列表
export const findWayList = p => post(`/${tmsPlus}/way/findWayList`, p)
// 运单新建
export const addWay = p => post(`/${tmsPlus}/way/addWay`, p)
// 运单修改
export const updateWay = p => post(`/${tmsPlus}/way/updateWay`, p)
// 修改装卸凭证
export const updateProof = p => post(`/${tmsPlus}/way/updateProof`, p)
// 作废运单
export const voidWay = p => post(`/${tmsPlus}/way/voidWay`, p)
// 运单详情
export const getWaynfo = p => post(`/${tmsPlus}/way/getWaynfo`, p)
// 附件列表
export const findWayFiles = p => post(`/${tmsPlus}/way/findWayFiles`, p)
// 获取凭证
export const findWayAttachments = p => post(`/${tmsPlus}/way/findWayAttachments`, p)
// 撤销运单
export const cancelWay = p => post(`/${tmsPlus}/way/cancelWay`, p)
// 生成往返
export const cancelRoundTripNo = p => post(`/${tmsPlus}/way/cancelRoundTripNo`, p)
// 取消往返
export const createRoundTripNo = p => post(`/${tmsPlus}/way/createRoundTripNo`, p)
// 调价记录
export const findPriceAdjustmentRecord = p => post(`/${tmsPlus}/way/findPriceAdjustmentRecord`, p)
// 修改仓储费
export const updateWayStorageCharges = p => post(`/${tmsPlus}/way/updateWayStorageCharges`, p)
// 修改运单支出
export const updateWayFreight = p => post(`/${tmsPlus}/way/updateWayFreight`, p)
// 修改运单收入
export const updateWayIncome = p => post(`/${tmsPlus}/way/updateWayIncome`, p)
// 运单打印
export const printWayInfoList = p => post(`/${tmsPlus}/way/printWayInfoList`, p)
// 运单管理统计字段
export const findWayListStatistics = p => post(`/${tmsPlus}/way/findWayListStatistics`, p)
// 配车
export const distributeCar = p => post(`/${tmsPlus}/way/distributeCar`, p)
// 运单管理-运单详情-结算信息
export const getSettlementRecordForWay = p => post(`/${tmsPlus}/settlementBill/getSettlementRecordForWay`, p)
// 运单管理-运单详情-发票信息
export const getInvoiceRecordForWay = p => post(`/${tmsPlus}/settlementBill/getInvoiceRecordForWay`, p)

// 财务管理
// 应收明细、应付明细列表
export const findWayBusinessList = p => post(`/${tmsPlus}/settlementBill/findWayBusinessList`, p)
// 应收明细对账-生成账单
export const addSettlementBillForYs = p => post(`/${tmsPlus}/settlementBill/addSettlementBillForYs`, p)
// 应付明细对账-生成账单
export const addSettlementBillForYf = p => post(`/${tmsPlus}/settlementBill/addSettlementBillForYf`, p)
// 账单管理-撤销对账
export const delSettlementBill = p => post(`/${tmsPlus}/settlementBill/delSettlementBill`, p)
// 账单管理查询
export const getSettlementBillList = p => post(`/${tmsPlus}/settlementBill/getSettlementBillList`, p)
// 账单管理-添加应收
export const addSettlementBillWayForYs = p => post(`/${tmsPlus}/settlementBill/addSettlementBillWayForYs`, p)
// 账单管理-添加应付
export const addSettlementBillWayForYf = p => post(`/${tmsPlus}/settlementBill/addSettlementBillWayForYf`, p)
// 账单管理-删除应收
export const delSettlementBillWayForYs = p => post(`/${tmsPlus}/settlementBill/delSettlementBillWayForYs`, p)
// 账单管理-删除应付
export const delSettlementBillWayForYf = p => post(`/${tmsPlus}/settlementBill/delSettlementBillWayForYf`, p)
// 内部核算-应付账单管理-确认
export const confirmSettlementBill = p => post(`/${tmsPlus}/settlementBill/confirmSettlementBill`, p)
// 内部核算-应付账单管理-撤销确认
export const revokeConfirmSettlementBill = p => post(`/${tmsPlus}/settlementBill/revokeConfirmSettlementBill`, p)
// 应收结算-账单管理-一键收款
export const allPaymentForYs = p => post(`/${tmsPlus}/settlementBill/allPaymentForYs`, p)
// 应收结算-账单管理-撤销收款
export const delSettlementRecord = p => post(`/${tmsPlus}/settlementBill/delSettlementRecord`, p)
// 收款记录、付款记录查询
export const getSettlementRecordMasterList = p => post(`/${tmsPlus}/settlementBill/getSettlementRecordMasterList`, p)
// 应收结算-账单管理-一键开票
export const allInvoiceForYs = p => post(`/${tmsPlus}/settlementBill/allInvoiceForYs`, p)
// 应收结算-账单管理-撤销开票
export const delInvoiceRecord = p => post(`/${tmsPlus}/settlementBill/delInvoiceRecord`, p)
// 应收结算-账单管理-开票记录查询
export const getInvoiceRecordMasterList = p => post(`/${tmsPlus}/settlementBill/getInvoiceRecordMasterList`, p)
// 应收结算-账单管理-勾选运单收款
export const wayPaymentForYs = p => post(`/${tmsPlus}/settlementBill/wayPaymentForYs`, p)
// 应收结算-账单管理-勾选运单开票
export const wayInvoiceForYs = p => post(`/${tmsPlus}/settlementBill/wayInvoiceForYs`, p)
// 应收结算-账单管理-勾选运单部分收款
export const waySomePaymentForYs = p => post(`/${tmsPlus}/settlementBill/waySomePaymentForYs`, p)
// 应收结算-账单管理-勾选运单部分开票
export const waySomeInvoiceForYs = p => post(`/${tmsPlus}/settlementBill/waySomeInvoiceForYs`, p)
// 应付结算-账单管理-一键付款
export const allPaymentForYf = p => post(`/${tmsPlus}/settlementBill/allPaymentForYf`, p)
// 应付结算-账单管理-一键开票
export const allInvoiceForYf = p => post(`/${tmsPlus}/settlementBill/allInvoiceForYf`, p)
// 应付结算-账单管理-勾选运单付款
export const wayPaymentForYf = p => post(`/${tmsPlus}/settlementBill/wayPaymentForYf`, p)
// 应付结算-账单管理-勾选运单开票
export const wayInvoiceForYf = p => post(`/${tmsPlus}/settlementBill/wayInvoiceForYf`, p)
// 应付结算-账单管理-勾选运单部分付款
export const waySomePaymentForYf = p => post(`/${tmsPlus}/settlementBill/waySomePaymentForYf`, p)
// 应付结算-账单管理-勾选运单部分开票
export const waySomeInvoiceForYf = p => post(`/${tmsPlus}/settlementBill/waySomeInvoiceForYf`, p)
// 部门收支大表
export const departmentQuery = p => post(`/${tmsPlus}/table/departmentQuery`, p)
// 批量修改付款申请单号
export const updatePaymentOaNo = p => post(`/${tmsPlus}/table/updatePaymentOaNo`, p)
// 批量修改业务提成
export const updateBusinessCommission = p => post(`/${tmsPlus}/table/updateBusinessCommission`, p)
// 部门人员导入业务提成
export const importBusinessCommission = p => post(`/${tmsPlus}/table/importBusinessCommission`, p)
// 集团收支大表
export const tenantyQuery = p => post(`/${tmsPlus}/table/tenantyQuery`, p)
// 分子公司收支大表
export const companyQuery = p => post(`/${tmsPlus}/table/companyQuery`, p)

// 司机列表
export const cDlist = p => post(driverName + '/cDriverInfo/list', p)
// 车辆列表
export const cVIlist = p => post(driverName + '/cVehicleInfo/list', p)
// 风险管理-异常风险
// 查看异常上报
export const exceptionList = p => post(`/${tmsPlus}/exception/list`, p)
// 异常上报查看照片
export const exceptionGetImage = p => post(`/${tmsPlus}/exception/getImage`, p)
// 长期货源===
// 长期货源列表查询
export const sourceList = p => post(`/${tmsPlus}/source/list`, p)
// 长期货源删除
export const sourceDelete = p => post(`/${tmsPlus}/source/sourceDelete`, p)
// 长期货源开启
export const sourceStart = p => post(`/${tmsPlus}/source/sourceStart`, p)
// 长期货源停用
export const sourceStop = p => post(`/${tmsPlus}/source/sourceStop`, p)
// 长期货源结束
export const sourceFinish = p => post(`/${tmsPlus}/source/sourceFinish`, p)
// 长期货源新建
export const addSource = p => post(`/${tmsPlus}/source/addSource`, p)
// 长期货源修改
export const updateSource = p => post(`/${tmsPlus}/source/updateSource`, p)
// 长期货源查看已用次数列表
export const takeRecordList = p => post(`/${tmsPlus}/order/takeRecord/list`, p)

// 车队长记忆功能
export const findVehicleLeaderList = p => post(`/${tmsPlus}/way/findVehicleLeaderList`, p)
// 导入首钢价格模板
export const importShougangPrice = p => post(`/${tmsPlus}/priceShougang/importShougangPrice`, p)
// 首钢价格查询
export const shougangList = p => post(`/${tmsPlus}/priceShougang/list`, p)

// 货主端接口
// 订单列表
export const findOwnerOrderList = p => post(`/${tmsPlus}/order/findOwnerOrderList`, p)
// 订单新建
export const addOwnerOrder = p => post(`/${tmsPlus}/order/addOwnerOrder`, p)
// 订单修改
export const updateOwnerOrder = p => post(`/${tmsPlus}/order/updateOwnerOrder`, p)
// 发布订单
export const orderPublish = p => post(`/${tmsPlus}/order/orderPublish`, p)
// 删除订单
export const deleteOwnerOrder = p => post(`/${tmsPlus}/order/deleteOwnerOrder`, p)
// 完成订单
export const completeOwnerOrder = p => post(`/${tmsPlus}/order/completeOwnerOrder`, p)
// 撤回订单
export const revocationOwnerOrder = p => post(`/${tmsPlus}/order/revocationOwnerOrder`, p)

// 首钢配载
// 校验运输计划号在不在订单存在
export const checkTransportPlanNo = p => post(`/${tmsPlus}/order/checkTransportPlanNo`, p)
// 仓储修改运输计划号校验
export const checkNewOldTransportPlanNo = p => post(`/${tmsPlus}/order/checkNewOldTransportPlanNo`, p)
// 首钢配载判断货物是否已在订单上
export const findSgStowageOrderGoodsYn = p => post(`/${tmsPlus}/order/findSgStowageOrderGoodsYn`, p)
// 首钢配载查询子订单为待处理、处理中
export const findSgStowageSonOrder = p => post(`/${tmsPlus}/order/findSgStowageSonOrder`, p)
// 首钢配载-配载提交
export const sgStowageSubmit = p => post(`/${tmsPlus}/order/sgStowageSubmit`, p)
// 首钢配载-收发地修改
export const updateSgStowageReceiveDeliver = p => post(`/${tmsPlus}/order/updateSgStowageReceiveDeliver`, p)
// 首钢配载-主订单修改
export const updateSgStowageMainOrder = p => post(`/${tmsPlus}/order/updateSgStowageMainOrder`, p)
// 首钢配载-运单作废
export const voidSgStowageWay = p => post(`/${tmsPlus}/order/voidSgStowageWay`, p)
// 查询首钢货物列表
export const getWMSGoodsPlus = p => post(`/${tmsPlus}/order/getWMSGoodsPlus`, p)
// 取得与车牌号关联的最近的一条运单信息
export const getWayForPlateNumber = p => post(`/${tmsPlus}/way/getWayForPlateNumber`, p)
// 获取网货司机
export const getDriverInfo = p => post(`/${tmsPlus}/online/getDriverInfo`, p)
// 获取网货司机下面的车辆
export const getVehicleInfo = p => post(`/${tmsPlus}/online/getVehicleInfo`, p)
// 获取网货客户服务税率
export const getCustomerTaxRate = p => post(`/${tmsPlus}/online/getCustomerTaxRate`, p)
// 获取网货装卸凭证
export const queryWayImg = p => post(`/${tmsPlus}/online/queryWayImg`, p)
// 新增网货装卸凭证
export const insertWayImg = p => post(`/${tmsPlus}/online/insertWayImg`, p)
// 删除网货装卸凭证
export const delWayImg = p => post(`/${tmsPlus}/online/delWayImg`, p)
// 网货查看运单审核结果
export const queryWayAuditDetail = p => post(`/${tmsPlus}/online/queryWayAuditDetail`, p)
// 判断是否推网货
export const pushWayToWHPTFlag = p => post(`/${tmsPlus}/way/pushWayToWHPTFlag`, p)
// 查看网货发票凭证
export const queryInvoiceFile = p => post(`/${tmsPlus}/online/queryInvoiceFile`, p)
// 查看网货上游结算凭证
export const queryUpstreamSettlementFile = p => post(`/${tmsPlus}/online/queryUpstreamSettlementFile`, p)
// 长期货源指派司机
export const addOrDeleteBinddingDriver = p => post(`/${tmsPlus}/source/addOrDeleteBinddingDriver`, p)
// 长期货源已绑定的司机
export const getSourceBinddingDrivers = p => post(`/${tmsPlus}/bindingRel/getSourceBinddingDrivers`, p)
// 报表统计-应收跟踪
export const getReportStatisticsYsList = p => post(`/${tmsPlus}/settlementBill/getReportStatisticsYsList`, p)
// 首钢配载收货地址
export const getLocalAddress = p => post(`/${tmsPlus}/sAddress/getLocalAddress`, p)
// 价格模板-获取收入价格
export const getPrice = p => post(`/${tmsPlus}/priceShougang/getPrice`, p)
// 首钢创建提单
export const addBill = p => post(`/${tmsPlus}/sg/addOrderBill`, p)
// 首钢配载
export const addSgStowage = p => post(`/${tmsPlus}/sg/addSgStowage`, p)
// 订单管理 - 提单型订单-查询接口
export const getOrderBill = p => post(`/${tmsPlus}/sg/getOrderBill`, p)
// 订单管理 - 提单型订单-修改接口
export const updateOrderBill = p => post(`/${tmsPlus}/sg/updateOrderBill`, p)
// 运单管理 - 签收
export const signForWay = p => post(`/${tmsPlus}/way/signForWay`, p)
// 运单管理 - 网货备注
export const updateOnlineRemark = p => post(`/${tmsPlus}/way/updateOnlineRemark`, p)
// 获取公里数
export const findKilometres = p => post(`/${tmsPlus}/order/findKilometres`, p)
// 校验重量件数必填项
export const checkRequiredFields = p => post(`/${tmsPlus}/order/checkRequiredFields`, p)
// 首钢配载修改卸货地
export const updateUnloadingSiteForTms = p => post(`/${wmsAccessName}/instock/updateUnloadingSiteForTms`, p)
// 应收结算-账单管理-申请开票校验
export const invoiceApplyCheckForYsBillList = p => post(`/${tmsPlus}/settlementBill/invoiceApplyCheckForYsBillList`, p)
// 应收结算-账单管理-申请开票确认
export const invoiceApplyForYsBillList = p => post(`/${tmsPlus}/settlementBill/invoiceApplyForYsBillList`, p)
// 应收结算-账单详情-勾选运单申请开票校验
export const invoiceApplyCheckForYsWayList = p => post(`/${tmsPlus}/settlementBill/invoiceApplyCheckForYsWayList`, p)
// 应收结算-账单详情-勾选运单申请开票确认
export const invoiceApplyForYsWayList = p => post(`/${tmsPlus}/settlementBill/invoiceApplyForYsWayList`, p)
// 发票管理查询
export const getInvoiceRecordApplyList = p => post(`/${tmsPlus}/settlementBill/getInvoiceRecordApplyList`, p)
// 发票管理-撤销申请&删除
export const delInvoiceRecordApply = p => post(`/${tmsPlus}/settlementBill/delInvoiceRecordApply`, p)
// 发票管理-开票确定
export const confirmInvoiceApply = p => post(`/${tmsPlus}/settlementBill/confirmInvoiceApply`, p)
// 发票管理-驳回
export const rejectInvoiceApply = p => post(`/${tmsPlus}/settlementBill/rejectInvoiceApply`, p)
// 发票管理-修改开票时间
export const updateInvoiceTime = p => post(`/${tmsPlus}/settlementBill/updateInvoiceTime`, p)
// 发票管理-撤销开票
export const revokeInvoiceApply = p => post(`/${tmsPlus}/settlementBill/revokeInvoiceApply`, p)
// 发票管理-二维码OCR识别结果匹配开票申请单
export const matchInvoiceApply = p => post(`/${tmsPlus}/settlementBill/matchInvoiceApply`, p)
// orr 相关接口
export const ocrCustomModelByFile = p => post(`/${signature}/api/ocrCustomModelByFile`, p)
export const ocrModelList = p => post(`/${signature}/api/ocrModelList`, p)

// 订单管理-加货
export const addGoods = p => post(`/${tmsPlus}/order/addGoods`, p)
// 订单管理-生码
export const rawCode = p => post(`/${tmsPlus}/orderQrCode/rawCode`, p)
// 订单管理-二维码回显
export const orderQrCodeDetail = p => post(`/${tmsPlus}/orderQrCode/detail`, p)
// 运单管理-签收-通知司机
export const updateImageAbnormal = p => post(`/${tmsPlus}/way/updateImageAbnormal`, p)
// 结算客户下拉框
export const findWayPayeeList = p => post(`/${tmsPlus}/way/findWayPayeeList`, p)
// 应付明细-推送风控平台
export const addRiskControlInfo = p => post(`/${tmsPlus}/riskControlInfo/addRiskControlInfo`, p)
// 风控反馈列表
export const findRiskControlInfoList = p => post(`/${tmsPlus}/riskControlInfo/findRiskControlInfoList`, p)
// 货物追踪列表
export const findWayGoodsList = p => post(`/${tmsPlus}/way/findWayGoodsList`, p)
// 应付结算-账单管理-一键付款校验风控平台
export const allPaymentForYfCheck = p => post(`/${tmsPlus}/settlementBill/allPaymentForYfCheck`, p)
// 应付结算-风控反馈-运单明细-撤回
export const removeRiskControlInfo = p => post(`/${tmsPlus}/riskControlInfo/removeRiskControlInfo`, p)
// 应付结算-账单管理-付款批注
export const paymentAnnotation = p => post(`/${tmsPlus}/settlementBill/paymentAnnotation`, p)
// 应付结算-账单管理-取消付款批注
export const revokePaymentAnnotation = p => post(`/${tmsPlus}/settlementBill/revokePaymentAnnotation`, p)
// 客户价格模板
export const findPriceCustomerList = p => post(`/${tmsPlus}/priceCustomer/findPriceCustomerList`, p)// 列表
export const addPriceCustomer = p => post(`/${tmsPlus}/priceCustomer/addPriceCustomer`, p)// 添加
export const updatePriceCustomer = p => post(`/${tmsPlus}/priceCustomer/updatePriceCustomer`, p)// 修改
export const deletePriceCustomer = p => post(`/${tmsPlus}/priceCustomer/deletePriceCustomer`, p)// 删除
export const getPriceCustomerForVehicleLength = p => post(`/${tmsPlus}/priceCustomer/getPriceCustomerForVehicleLength`, p)// 查询客户价格

// 各种统计
export const findWayBusinessListTotal = p => post(`/${tmsPlus}/settlementBill/findWayBusinessListTotal`, p)// 应收应付相关页面列表的合计统计
export const getSettlementBillListTotal = p => post(`/${tmsPlus}/settlementBill/getSettlementBillListTotal`, p)// 账单管理查询的合计统计
export const departmentQueryTotal = p => post(`/${tmsPlus}/table/departmentQueryTotal`, p)// 收支大表--部门查询 合计统计
export const companyQueryTotal = p => post(`/${tmsPlus}/table/companyQueryTotal`, p)// 收支大表--公司查询 合计统计
export const tenantyQueryTotal = p => post(`/${tmsPlus}/table/tenantyQueryTotal`, p)//  收支大表--公司查询 合计统计
// 自由车价格模板
export const findPriceVehicleList = p => post(`/${tmsPlus}/priceVehicle/findPriceVehicleList`, p)// 应用的接口
export const findPriceVehicleLists = p => post(`/${tmsPlus}/priceVehicle/findPriceVehicleLists`, p)// 列表
export const addPriceVehicle = p => post(`/${tmsPlus}/priceVehicle/addPriceVehicle`, p)// 添加
export const updatePriceVehicle = p => post(`/${tmsPlus}/priceVehicle/updatePriceVehicle`, p)// 修改
export const deletePriceVehicle = p => post(`/${tmsPlus}/priceVehicle/deletePriceVehicle`, p)// 删除
// 报警设置 新增修改删除
export const addOrUpTimeoutReminder = p => post(`/${tmsPlus}/dictionary/addOrUpTimeoutReminder`, p)
// 一分调价
export const updateFreightTotal = p => post(`/${tmsPlus}/way/updateFreightTotal`, p)
// 应付账单-审核通过or审核驳回-确定
export const settlementBillAudit = p => post(`/${tmsPlus}/settlementBill/settlementBillAudit`, p)
// 查询审核流程记录列表
export const tAuditRecordList = p => post(`/${tmsPlus}/tAuditRecord/list`, p)
// 推送网货
export const riskControlPush = p => post(`/${tmsPlus}/way/riskControlPush`, p)
// 版本列表
export const findVersionManagementList = p => post(`/${tmsPlus}/versionManagement/findVersionManagementList`, p)
// 版本新增修改
export const operationVersionManagement = p => post(`/${tmsPlus}/versionManagement/operationVersionManagement`, p)
// 删除版本
export const deleteVersionManagement = p => post(`/${tmsPlus}/versionManagement/deleteVersionManagement`, p)
// 选司机带车承运商id
export const findDriverInfoById = (p) => post(driverName + '/cDriverInfo/findDriverInfoById', p)
// 回收站订单列表
export const findRecycleOrderList = (p) => post(`/${tmsPlus}/order/findRecycleOrderList`, p)
// 回收站运单列表
export const findRecycleWayList = (p) => post(`/${tmsPlus}/way/findRecycleWayList`, p)
// 运单克隆
export const copyWay = (p) => post(`/${tmsPlus}/way/copyWay`, p)
// 首钢计划
export const find3PLOrderList = (p) => post(`/${tmsPlus}/order/find3PLOrderList`, p)
// 首钢计划-货物列表
export const find3PLOrderGoodsList = (p) => post(`/${tmsPlus}/order/find3PLOrderGoodsList`, p)
// 首钢计划-批量修改收发地址
export const update3PLDeliverReceiving = (p) => post(`/${tmsPlus}/order/update3PLDeliverReceiving`, p)
// 首钢计划-派车
export const sendCar = (p) => post(`/${tmsPlus}/order/sendCar`, p)
// 首钢计划-换车
export const updateSendCar = (p) => post(`/${tmsPlus}/order/updateSendCar`, p)
// 首钢计划-取消派车
export const deleteSendCar = (p) => post(`/${tmsPlus}/order/deleteSendCar`, p)
// 首钢计划-收入结算
export const update3PLIncome = (p) => post(`/${tmsPlus}/order/update3PLIncome`, p)
// 导出字段设置
export const queryYesSettingExportFiles = (p) => post(`/${tmsPlus}/dynamic/field/queryYesSettingExportFiles`, p)// 查询已设置的导出字段
export const queryMyExportPageField = (p) => post(`/${tmsPlus}/dynamic/field/queryMyExportPageField`, p)// 查询导出要设置的字段
export const saveOrUpdateOrRemoveExport = (p) => post(`/${tmsPlus}/dynamic/myField/saveOrUpdateOrRemoveExport`, p)// 保存导出字段
// 运单管理承运商下拉
export const findGcDropDownBox = (p) => post(`/${tmsPlus}/way/findGcDropDownBox`, p)

// 判断运单收入是否可以修改(针对转包来的订单生成的运单)
export const checkOrderSource = (p) => post(`/${tmsPlus}/order/checkOrderSource`, p)

// 无账单开票
export const confirmInvoiceApplyNoBills = (p) => post(`/${tmsPlus}/tInvoiceRecordApply/confirmInvoiceApplyNoBills`, p)
// 无账单开票-关联账单
export const invoiceApplyAddYsBillList = (p) => post(`/${tmsPlus}/tInvoiceRecordApply/invoiceApplyAddYsBillList`, p)
// 无账单开票-撤销关联
export const invoiceApplyDeleteYsBillList = (p) => post(`/${tmsPlus}/tInvoiceRecordApply/invoiceApplyDeleteYsBillList`, p)
// 无账单开票-删除发票
export const delInvoiceRecordApplyNoBill = (p) => post(`/${tmsPlus}/tInvoiceRecordApply/delInvoiceRecordApplyNoBill`, p)

// 开票报表
export const saveSummary = (p) => post(`/${tmsPlus}/customerMonthlySummary/saveSummary`, p)// 生成月汇总
export const findMonthSummaryList = (p) => post(`/${tmsPlus}/customerMonthlySummary/findMonthSummaryList`, p)// 月汇总列表
export const findMonthSummaryTotal = (p) => post(`/${tmsPlus}/customerMonthlySummary/findMonthSummaryTotal`, p)// 月汇总列表合计
export const deleteSummary = (p) => post(`/${tmsPlus}/customerMonthlySummary/deleteSummary`, p)// 删除
export const auditSummary = (p) => post(`/${tmsPlus}/customerMonthlySummary/auditSummary`, p)// 审核
export const updateSummary = (p) => post(`/${tmsPlus}/customerMonthlySummary/updateSummary`, p)// 更新月汇总
export const certificate = (p) => post(`/${tmsPlus}/customerMonthlySummary/certificate`, p)// 凭证

export const findCustomerMonthList = (p) => post(`/${tmsPlus}/customerMonthlySummary/findCustomerMonthList`, p)// 客户月列表
export const findCustomerMonthTotal = (p) => post(`/${tmsPlus}/customerMonthlySummary/findCustomerMonthTotal`, p)// 客户月列表合计
export const findAmountReceivableInfo = (p) => post(`/${tmsPlus}/customerMonthlySummary/findAmountReceivableInfo`, p)// 应收金额明细
export const findCustomerList = (p) => post(`/${tmsPlus}/customerMonthlySummary/findCustomerList`, p)// 结算客户下拉

// 一分调价应收
export const updateGrossRevenue = p => post(`/${tmsPlus}/way/updateGrossRevenue`, p)
// 修改记录列表
export const findWayUpdateRecordList = p => post(`/${tmsPlus}/updateRecord/findWayUpdateRecordList`, p)
// 修改记录统计
export const findWayUpdateRecordTotal = p => post(`/${tmsPlus}/updateRecord/findWayUpdateRecordTotal`, p)
// 财务4个报表 撤销审核
export const revokeAuditSummary = p => post(`/${tmsPlus}/customerMonthlySummary/revokeAuditSummary`, p)

// 船舶信息
export const shipList = p => post(`/${tmsPlus}/ship/list`, p)
export const shipAdd = p => post(`/${tmsPlus}/ship/add`, p)
export const shipUpdate = p => post(`/${tmsPlus}/ship/update`, p)
export const shipDelete = p => post(`/${tmsPlus}/ship/delete`, p)
// 首钢配载获取业务人员信息
export const getSgpzInfo = p => post(`/${tmsPlus}/dictionary/getSgpzInfo`, p)
// 应收账单管理-批量收款
export const allBatchPaymentForYs = p => post(`/${tmsPlus}/settlementBill/allBatchPaymentForYs`, p)

// 能源费用
export const saveOrUpdateCostWithAttachments = p => post(`/${tmsPlus}/costRecord/saveOrUpdateCostWithAttachments`, p)// pc端费用上报新增修改
export const costRecordList = p => post(`/${tmsPlus}/costRecord/list`, p)// 费用上报列表
export const deleteCostRecord = p => post(`/${tmsPlus}/costRecord/deleteCostRecord`, p)// 删除费用上报
export const auditCostRecord = p => post(`/${tmsPlus}/costRecord/auditCostRecord`, p)// 费用上报审核
export const getOilCostDetail = p => post(`/${tmsPlus}/costRecord/getOilCostDetail`, p)// 费用上报详情
export const costRecordImport = p => post(`/${tmsPlus}/costRecord/import`, p)// 费用导入（过路费、充电费)
export const auditCostRecords = p => post(`/${tmsPlus}/costRecord/auditCostRecords`, p)// 批量审核
// 充电记录 维修记录
export const pcRechargeOnlineList = p => post(`${tmsPlus}/rechargeOnline/pcRechargeOnlineList`, p)// PC端 充电管理列表查询
export const driverDeleteRechargeOnline = p => post(`${tmsPlus}/rechargeOnline/driverDeleteRechargeOnline`, p)// 删除充电记录（只可删除已完成的）
export const driverUpdateRechargeOnline = p => post(`${tmsPlus}/rechargeOnline/driverUpdateRechargeOnline`, p)// 修改充电记录
// 运单管理-推送港口
export const pushWharf = p => post(`${tmsPlus}/driverApp/pushWharf`, p)

// 司机排队列表
export const relList = p => post(driverName + '/cDriverQueue/relList', p)
// 运单-风控
export const signRisk = p => post(`${tmsPlus}/way/signRisk`, p)

// 回收站运单-恢复
export const wayRevert = p => post(`${tmsPlus}/way/wayRevert`, p)

// 订单管理-流转
export const transferOrder = p => post(`${tmsPlus}/order/transferOrder`, p)
//  订单管理-承运
export const carryOrder = p => post(`${tmsPlus}/order/carryOrder`, p)
//  订单管理-退回
export const returnOrder = p => post(`${tmsPlus}/order/returnOrder`, p)
//  运单管理-取消车次号
export const cancelWayTrainNumber = p => post(`${tmsPlus}/way/cancelWayTrainNumber`, p)
// 车辆状态分布
export const statByTimeSlot = p => post(`${tmsPlus}/tWayVehicleReport/statByTimeSlot`, p)
// 项目出车情况
export const waySummary = p => post(`${tmsPlus}/tWayVehicleReport/waySummary`, p)
// 司机日工作情况
export const dailyWork = p => post(`${tmsPlus}/tWayVehicleReport/dailyWork`, p)
// 业务拉运占比
export const businessProportionReport = p => post(`${tmsPlus}/tReportDataView/businessProportionReport`, p)
// 司机趟费报表
export const findDriverTollFee = p => post(`${tmsPlus}/reportw/findDriverTollFee`, p)
// 项目收支报表
export const findProjectRevenue = p => post(`${tmsPlus}/reportw/findProjectRevenue`, p)
// 车辆拉运报表
export const vehicleTransportReport = p => post(`${tmsPlus}/tReportDataView/vehicleTransportReport`, p)
// 小队收支报表
export const findTeamRevenue = p => post(`${tmsPlus}/reportw/findTeamRevenue`, p)
// 项目拉运统计报表
export const findProjectTransportation = p => post(`${tmsPlus}/reportw/findProjectTransportation`, p)
// 自有车统计-小队项目拉运情况
export const teamProjectTransportReport = p => post(`${tmsPlus}/tReportDataView/teamProjectTransportReport`, p)
// 运营报表-仓库货物拉运 自有车外协车占比
export const findAnalysisPercentage = p => post(`${tmsPlus}/reportw/findAnalysisPercentage`, p)
// 工具助手-流量收支模型
export const directionPriceModelList = p => post(`${tmsPlus}/directionPriceModel/directionPriceModelList`, p)
// 运单导入
export const importWay = p => post(`${tmsPlus}/way/importWay`, p)
// 单车核算
export const vehicleAccountingQuery = p => post(`${tmsPlus}/vehicleAccounting/query`, p)
// 天津中物新增地址，简化版
export const addSimplification = p => post(`/${tmsPlus}/sAddress/addSimplification`, p)
// 天津中物修改地址，简化版
export const updateSimplification = p => post(`/${tmsPlus}/sAddress/updateSimplification`, p)
// 查询订单归档资料
export const findOrderArchivedData = p => post(`/${tmsPlus}/order/findOrderArchivedData`, p)
// 订单新增归档资料
export const addOrderArchivedData = p => post(`/${tmsPlus}/order/addOrderArchivedData`, p)
// 删除订单归档资料
export const deleteOrderArchivedData = p => post(`/${tmsPlus}/order/deleteOrderArchivedData`, p)
// 订单修改归档资料
export const updateOrderArchivedData = p => post(`/${tmsPlus}/order/updateOrderArchivedData`, p)
// 个人核算
export const driverQueryPage = p => post(`/${tmsPlus}/vehicleAccounting/driverQueryPage`, p)
// 单车核算-月度核算列表查询
export const tVehicleAccountingList = p => post(`/${tmsPlus}/tVehicleAccountingDetail/list`, p)
// 单车核算-月度核算生成
export const tVehicleAccountingGenerate = p => post(`/${tmsPlus}/tVehicleAccountingDetail/generate`, p)
// 单车核算-月度核算更新
export const tVehicleAccountingUpdate = p => post(`/${tmsPlus}/tVehicleAccountingDetail/update`, p)
// 单车核算-月度核算删除
export const tVehicleAccountingDelete = p => post(`/${tmsPlus}/tVehicleAccountingDetail/delete`, p)
// 单车核算-核算明细查询
export const tVehicleAccountingDetails = p => post(`/${tmsPlus}/tVehicleAccountingDetail/detail`, p)
// 单车核算-核算审核
export const tVehicleAccountingAudit = p => post(`/${tmsPlus}/tVehicleAccountingDetail/audit`, p)
// 单人核算-月度核算列表查询
export const tDriverAccountingList = p => post(`/${tmsPlus}/tDriverAccountingDetail/list`, p)
// 单人核算-月度核算生成
export const tDriverAccountingGenerate = p => post(`/${tmsPlus}/tDriverAccountingDetail/generate`, p)
// 单人核算-月度核算更新
export const tDriverAccountingUpdate = p => post(`/${tmsPlus}/tDriverAccountingDetail/update`, p)
// 单人核算-月度核算删除
export const tDriverAccountingDelete = p => post(`/${tmsPlus}/tDriverAccountingDetail/delete`, p)
// 单人核算-核算明细查询
export const tDriverAccountingDetails = p => post(`/${tmsPlus}/tDriverAccountingDetail/detail`, p)
// 单人核算-核算审核
export const tDriverAccountingAudit = p => post(`/${tmsPlus}/tDriverAccountingDetail/audit`, p)
// 司机薪资-生成
export const driverPayrollSummaryGenerate = p => post(`/${tmsPlus}/driverPayrollSummary/generate`, p)
// 司机薪资-更新
export const driverPayrollSummaryUpdate = p => post(`/${tmsPlus}/driverPayrollSummary/update`, p)
// 司机薪资-列表
export const driverPayrollSummaryList = p => post(`/${tmsPlus}/driverPayrollSummary/list`, p)
// 司机薪资-详情
export const driverPayrollSummaryDetail = p => post(`/${tmsPlus}/driverPayrollSummary/detail`, p)
// 机修工资-主表查询
export const getMainByMonth = p => post(`/${tmsPlus}/cRepairSalaryDetail/mainList`, p)
// 机修工资-子表查询
export const cRepairSalaryDetailList = p => post(`/${tmsPlus}/cRepairSalaryDetail/list`, p)
// 机修工资-子表新增
export const cRepairSalaryDetailAdd = p => post(`/${tmsPlus}/cRepairSalaryDetail/add`, p)
// 机修工资-子表修改
export const cRepairSalaryDetailupdate = p => post(`/${tmsPlus}/cRepairSalaryDetail/update`, p)
// 机修工资-子表删除
export const cRepairSalaryDetaildelete = p => post(`/${tmsPlus}/cRepairSalaryDetail/delete`, p)
// 机修工资-子表导入
export const cRepairSalaryDetailimport = p => post(`/${tmsPlus}/cRepairSalaryDetail/import`, p)
// 外修费用-获取子表详情
export const getExternalRepairDetail = p => post(`/${tmsPlus}/costRecord/getExternalRepairDetail`, p)
// 应收结算、应付结算-账单管理-不开票
export const noInvoiceSettlementBill = p => post(`/${tmsPlus}/settlementBill/noInvoiceSettlementBill`, p)
// 物流运输大屏-实时运单
export const findRealTimeWayBill = p => post(`/${tmsPlus}/way/findRealTimeWayBill`, p)
// 中物物流数据大屏-单日拉运情况
export const getWayForToday = p => post(`/${tmsPlus}/way/getWayForToday`, p)
// 中物物流数据大屏-总运量、总车次、总车辆、总司机、承运商
export const getAllTotalValue = p => post(`/${tmsPlus}/way/getAllTotalValue`, p)
// 应付结算-账单管理-申请网货付款
export const wlhyPayment = p => post(`/${tmsPlus}/online/wlhyPayment`, p)
// 应付结算-账单管理-申请网货开票
export const wlhyInvoice = p => post(`/${tmsPlus}/online/wlhyInvoice`, p)
// 运营报表-基地仓位拉运占比-查看详情
export const findBaseWarehouseCustomerList = p => post(`/${tmsPlus}/reportw/findBaseWarehouseCustomerList`, p)
// 运营报表-流向明细毛利
export const findDirectionMlList = p => post(`/${tmsPlus}/reportw/findDirectionMlList`, p)
// 运营报表-客户明细毛利（公司）
export const findCustomerMlCompanyList = p => post(`/${tmsPlus}/reportw/findCustomerMlCompanyList`, p)
// 运营报表-客户明细毛利（部门）
export const findCustomerMlDepartmentList = p => post(`/${tmsPlus}/reportw/findCustomerMlDepartmentList`, p)
// 运营报表-应收账龄统计
export const getReportYsList = p => post(`/${tmsPlus}/rCustomer/getReportYsList`, p)
// 运营报表-成本账龄统计
export const getReportYfList = p => post(`/${tmsPlus}/rCustomer/getReportYfList`, p)
// 运营报表-客户收支表
export const customerExpend = p => post(`/${tmsPlus}/rCustomer/customerExpend`, p)
// 运营报表-业务提成依据表
export const businessSales = p => post(`/${tmsPlus}/rCustomer/businessSales`, p)
// 运营报表-多周期业务分析表
export const businessAnalysis = p => post(`/${tmsPlus}/rCustomer/businessAnalysis`, p)
// 运营报表-基地仓位拉运占比新
export const findBaseTransportationShare = p => post(`/${tmsPlus}/reportw/findBaseTransportationShare`, p)
// 运营报表项目收入支报表新
export const findProjectIncomeExpenditure = p => post(`/${tmsPlus}/reportw/findProjectIncomeExpenditure`, p)
// 基地仓拉运客户明细毛利表（汇总）
export const findBaseWarehouseCustomerAllList = p => post(`/${tmsPlus}/reportw/findBaseWarehouseCustomerAllList`, p)
// 加油加气新增20260821
export const saveOilGasFee = p => post(`/${tmsPlus}/costRecord/saveOilGasFee`, p)
// 加油加气修改20260821 加电批量修改
export const updateOilGasFee = p => post(`/${tmsPlus}/costRecord/updateOilGasFee`, p)
// 加油加气导入20260821
export const importOilGasFee = p => post(`/${tmsPlus}/costRecord/importOilGasFee`, p)
